import { SetPageStateValue } from 'src/shared/pageState';

import { usePageState } from './hooks/usePageState';

export function PageState() {
	const {
		data: { states },
	} = usePageState();

	return (
		<>
			{states.map(({ name, value }) => (
				<SetPageStateValue key={name} name={name} value={value} />
			))}
		</>
	);
}
